<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getAdmins()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Admins class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Admin</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in admins.data" :key="data.id" v-on:click="editAdmins(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_admins" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.email}}</td>
                                                <th>
                                                    <label v-if="data.is_active === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Active</label>
                                                    <label v-if="data.is_active === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> Not Active</label>
                                                </th>
                                                <td>{{data.created_at | formatDate}}</td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="admins.total === 0" class="text-center no-data">Admins data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="admins"
                                                :sorting="sorting"
                                                @paginate="getAdmins()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Admin Data Still Empty</h2>
                                    <p>On this page you can create admin user</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Admins class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Admin</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action ca-big" v-if="del_admins.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_admins = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_admins.length}}</span> admin selected</span>
                    </div>
                    <div class="float-right">
                        <div v-b-modal.modal-Status class="btn btn-grey mr-2">
                            <i class="uil uil-sync"></i> Status
                        </div>
                        <div v-on:click.prevent="alertDeleteAdmins()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_admins="del_admins" @getAdmins="getAdmins(),del_admins = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../admin/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "admins",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_admins:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getAdmins().then(() => {
                if(this.admins.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('AdminsControl', {
                admins: state => state.admins,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.admins.data ? this.del_admins.length == this.admins.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.admins.data.forEach(function (admins) {
                            if(admins.id !== 1){
                                selected.push(admins.id);
                            }
                        });
                    }

                    this.del_admins = selected;
                }
            }
        },
        methods: {
            ...mapActions('AdminsControl', ['getAdmins','deleteAdmins']),
            ...mapMutations('AdminsControl', ['CLEAR_ADMINS','ASSIGN_FORM']),
            
            editAdmins:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Admins')
            },
            alertDeleteAdmins:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this admin data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteAdmins(this.del_admins).then(
                            this.$toast.success('Successfully Deleting Admin'),
                            this.del_admins = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_ADMINS()
        }
    };

</script>
